import TabSwitch from "@common/component/TabSwitch";
import React, { useEffect, useRef, useState } from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { Button } from "react-native-elements";
import { ListSearchInput } from "../../../common/component";
import { FONT_FAMILY, THEME_COLORS } from "../../../common/themes";
import { InventoryTypeEnum, InventoryTypesList } from "./constants";
import { RefurbInventory } from "./RefurbInventory";
import OutboundInventory from "./OutboundInventory";
import DispatchInventory from "./DispatchInventory";
import { NavigationSwitchScreenProps } from "react-navigation";

function InventoryListingV3(props: NavigationSwitchScreenProps) {
  const { navigation } = props;
  const { search: searchParam = "", inventoryType: inventoryTypeParam = "" } = navigation.state?.params ?? {};

  const refurbInventoryRef = useRef<RefurbInventory>(null);

  const [search, setSearch] = useState(searchParam ? searchParam : "");
  const [inventoryType, setInventoryType] = useState(
    () => InventoryTypesList.find((it) => it.value === inventoryTypeParam) || InventoryTypesList[0]
  );

  useEffect(() => {
    navigation.setParams({ inventoryType: inventoryType.value });
  }, [inventoryType]);

  return (
    <>
      <ScrollView style={styles.container}>
        <View style={[styles.flexBox, { justifyContent: "space-between" }]}>
          <TabSwitch items={InventoryTypesList} value={inventoryType} onSelect={setInventoryType} />
          {/* @ts-ignore */}
          <View style={[styles.flexBox, { columnGap: 24, marginRight: "1em" }]}>
            <ListSearchInput
              searchProp={search}
              onSearch={setSearch}
              placeholder={
                inventoryType.value === InventoryTypeEnum.Refurb
                  ? "Search lead ID, cars, CGT..."
                  : "Search lead ID, cars, technician, inspector..."
              }
            />
            {inventoryType.value === InventoryTypeEnum.Refurb && (
              <Button
                buttonStyle={[styles.button, styles.addCarButton]}
                type="outline"
                title="+ ADD CAR"
                titleStyle={[styles.buttonTitle, styles.addCarTitle]}
                loadingProps={{ color: THEME_COLORS.purple }}
                onPress={() => {
                  refurbInventoryRef.current?.handleAddCar();
                }}
              />
            )}
          </View>
        </View>
        {inventoryType.value === InventoryTypeEnum.Refurb && (
          <RefurbInventory navigation={navigation} search={search} ref={refurbInventoryRef} />
        )}
        {inventoryType.value === InventoryTypeEnum.Outbound && (
          <OutboundInventory navigation={navigation} search={search} />
        )}
        {inventoryType.value === InventoryTypeEnum.Dispatch && (
          <DispatchInventory navigation={navigation} search={search} />
        )}
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    // @ts-ignore
    padding: "1.2em",
  },
  flexBox: { flexDirection: "row", alignItems: "center" },
  button: {
    // @ts-ignore
    paddingHorizontal: "1em",
    // @ts-ignore
    paddingVertical: "0.6em",
    backgroundColor: `${THEME_COLORS.purple}aa`,
    // @ts-ignore
    width: "fit-content",
    minWidth: 150,
  },
  buttonTitle: {
    fontSize: 14,
    fontFamily: FONT_FAMILY.mediumV3,
  },
  addCarButton: {
    backgroundColor: THEME_COLORS.white,
    borderColor: THEME_COLORS.purple,
  },
  addCarTitle: {
    color: THEME_COLORS.purple,
  },
});

export default InventoryListingV3;
